<template>
    <div>
        <div class="a-table--short-no-style">
            <table class="a-table a-table--full-width a-table--hover" cellpadding="0" cellspacing="0">
                <tr>
                    <th width="33%"><h2>Heads of Loss</h2></th>
                    <th width="33%"><h2>Amount</h2></th>
                    <th width="33%"><h2>Interest</h2></th>
                </tr>
                <tr>
                    <td>General Damages (PSLA)</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('generalDamages')) }}</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('generalDamagesWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Past Cost of Services</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastDependencyOnServices')) }}</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastDependencyOnServicesWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Past Cost of Care</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastCostOfCare')) }}</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastCostOfCareWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Past Cost of Travel</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastCostOfTravel')) }}</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastCostOfTravelWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Past Loss of Earnings</td>
                    <td>{{ currencyFormat(pastLossTotal) }}</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('pastLossOfEarningsWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Miscellaneous</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('misc')) }}</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('miscWithInterest')) }}</td>
                </tr>
                <tr v-if="allCustomHeadOfLoss.length > 0" v-for="(headOfLoss, key) in allCustomHeadOfLoss">
                    <td>{{ headOfLoss.name }}</td>
                    <td>{{ currencyFormat(headOfLoss.value) }}</td>
                    <td>{{ currencyFormat(headOfLoss.interestAccrued) }}</td>
                </tr>
                <tr>
                    <td>Future Cost of Services</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('futureDependencyOnServices')) }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Future Cost of Care</td>
                    <td>{{ currencyFormat(getHeadsOfLossValue('futureCostOfCare')) }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Future Loss of Earnings</td>
                    <td>{{ currencyFormat(futureLossTotal) }}</td>
                    <td></td>
                </tr>
                <tr v-if="cruTotalDeductions > 0">
                    <td>CRU Benefit Deductions</td>
                    <td>- {{ currencyFormat(cruTotalDeductions) }}</td>
                    <td></td>
                </tr>
                <tfoot>
                    <tr class="a-table--grey">
                        <td>Subtotal</td>
                        <td>{{ currencyFormat(subTotal) }}</td>
                        <td>{{ currencyFormat(interestTotal) }}</td>
                    </tr>
                    <tr class="a-table--penultimate">
                        <td>Total</td>
                        <td colspan="2">{{ currencyFormat(total) }}</td>
                    </tr>
                    <tr>
                        <td>Total <span>less interim payment(s)</span></td>
                        <td colspan="2">{{ currencyFormat(totalLessInterimPayments) }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div class="step-button flex-state-buttons flex-state-buttons--block a-table--center">
            <div>
                <router-link :to="{ name: 'lost::step-7' }" class="a-button" tag="button">
                    Back
                </router-link>
                <router-link :to="{ name: 'lost::documents.list', params : { id: claimId } }" class="a-button" tag="button">
                    View Documents
                </router-link>
            </div>
        </div>

        <reserves-for-claim></reserves-for-claim>

    </div>
</template>
<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import StepButton from 'components/StepButton.vue';
    import {mapActions, mapGetters} from 'vuex';
    import {prevStep} from 'services/routingMethods';
    import currencyFormat from 'mixins/currencyFormat';
    import modal from 'components/modal/Modal.vue';
    import dateFormat from 'mixins/dateFormat';
    import VueHtml5Editor from 'vue-html5-editor';
    import store from 'store/index';
    import ReservesForClaim from "pages/claims-dashboard/components/ReservesForClaim";

    const HtmlEditor = new VueHtml5Editor();

    const numberVal = value => parseFloat(value || 0);

    export default {
        name: 'calculate-loss',
        data() {
            return {
                editingContent: null,
                valid: false,
                theClaim: null,
                loading: false,
                isSaving: false,
            }
        },
        computed: {
            ...mapGetters('user', [
                'getToken',
            ]),
            ...mapGetters('documents', {
                getGeneratedDocuments: 'getGeneratedDocuments',
                getDocumentsByType: 'getDocumentsByType',
                getEditingDocument: 'getEditingDocument',
                requesting: 'getRequestStatus',
                findDocument: 'getGeneratedDocument'
            }),
            ...mapGetters('lost/headsOfLoss', ['getHeadsOfLossValue', 'getAllCustomHeadOfLoss', 'getAllCustomHeadOfLossTotal', 'getAllCustomHeadOfLossInterestTotal']),
            ...mapGetters('lost/interimPayments', ['getAllInterimPaymentsTotal']),
            ...mapGetters('lost/lossOfIncome', ['futureLossTotal', 'pastLossTotal']),
            ...mapGetters('lost/cruBenefits', ['getGeneralDamagesOffset', 'getPastLossOfEarningsOffset', 'getPastCostOfCareOffset', 'getPastCostOfTravelOffset']),
            ...mapGetters('http', ['apiRouteRequestRunning']),
            ...mapGetters('claim', { claimId: 'id' }),
            allCustomHeadOfLoss: {
                get(){
                    return this.getAllCustomHeadOfLoss;
                }
            },
            interestTotal() {
                return numberVal(this.getHeadsOfLossValue('generalDamagesWithInterest')) +
                    numberVal(this.getHeadsOfLossValue('pastDependencyOnServicesWithInterest')) +
                    numberVal(this.getHeadsOfLossValue('pastCostOfCareWithInterest')) +
                    numberVal(this.getHeadsOfLossValue('pastCostOfTravelWithInterest')) +
                    numberVal(this.getHeadsOfLossValue('pastLossOfEarningsWithInterest')) +
                    numberVal(this.getHeadsOfLossValue('miscWithInterest')) +
                    numberVal(this.getAllCustomHeadOfLossInterestTotal);
            },
            subTotal() {
                return numberVal(this.getHeadsOfLossValue('generalDamages')) +
                    numberVal(this.getHeadsOfLossValue('pastDependencyOnServices')) +
                    numberVal(this.getHeadsOfLossValue('futureDependencyOnServices')) +
                    numberVal(this.getHeadsOfLossValue('pastCostOfCare')) +
                    numberVal(this.getHeadsOfLossValue('pastCostOfTravel')) +
                    numberVal(this.pastLossTotal) +
                    numberVal(this.getHeadsOfLossValue('misc')) + 
                    numberVal(this.getAllCustomHeadOfLossTotal) + 
                    numberVal(this.getHeadsOfLossValue('futureCostOfCare')) + 
                    numberVal(this.futureLossTotal)  -
                    numberVal(this.cruTotalDeductions);
            },
            total() {
                return this.subTotal + this.interestTotal;
            },
            totalLessInterimPayments() {
                return this.total - numberVal(this.getAllInterimPaymentsTotal);
            },
            downloadUrl() {
                return '/api/v1/download/' + this.claimId+'?access_token='+this.getToken;
            },
            cruTotalDeductions() {
                return this.getGeneralDamagesOffset +
                    this.getPastLossOfEarningsOffset +
                    this.getPastCostOfCareOffset +
                    this.getPastCostOfTravelOffset;
            },
            uniqueId() {
                return this._uid;
            }
        },
        mixins: [
            currencyFormat,
            dateFormat
        ],
        components: {
            ReservesForClaim,
            Control,
            ControlError,
            HtmlEditor,
            StepButton
        },
        methods: {
            back () {
                if (this.prevValid) {
                    this.$router.push(prevStep().route);
                }
            },
            ...mapActions('modal', ['toggle']),
            ...mapActions('documents', {
                toggleContent: 'toggleEditingDocument',
                createGeneratedDocument: 'createGeneratedDocument',
                deleteGeneratedDocument: 'deleteGeneratedDocument',
                getGeneratedDocumentsFromServer: 'getGeneratedDocumentsFromServer',
            }),
            createDocument(type) {
                this.createGeneratedDocument({claimId: this.claimId, claimType: store.getters['claim/type'], type});
            },
            deleteDocument(document) {
                if (this.requesting) {
                    return;
                }
                this.deleteGeneratedDocument(document);
            },
            theDocument(index) {
                return this.findDocument(index);
            },
            requestInProgress() {
                return this.apiRouteRequestRunning('/api/v1/generated-documents/load')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// CalculateLoss.vue?84590220